import {Component, Input} from '@angular/core';
import {ServiceBagService} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";
import {BaseEntity, BaseState} from "@base/entities/BaseEntities";
import {BaseGridComponent} from "../../../../../base/component/BaseGridComponent";
import {DemoMobilePhoneBrand, DemoMobilePhoneModel} from "@ui/demo/models/demo-mobile-phone";
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';

@Component({
    selector: 'app-demo-grid',
    templateUrl: './demo-grid.component.html'
})
export class DemoGridComponent extends BaseGridComponent<BaseEntity, BaseState> {

    @Input() Brands: DemoMobilePhoneBrand[] = [];
    @Input() Models: DemoMobilePhoneModel[] = [];
    @Input() Colors: any[] = [];
    
    constructor(A: ServiceBagService) {
        super(A, 'DemoGridComponent', BaseEntity, BaseState);
    }

    override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [{
            text: this.RC('someContextMenuTitle'),
            onClick: () => console.log(options)
        }]
    }

    OnColumnClick(e) {
        console.log(e);
    }

}
